import { fmtForUI, parseMaybeNumber } from "../../../../helpers/common";

interface DriveInInputsType {
  edit1?: string | number;
  edit2?: string | number;
  edit3?: string | number;
  edit4?: string | number;
  edit5?: string | number;
  edit6?: string | number;
  edit7?: string | number;
  edit9?: string | number;
  edit27?: string | number;
  edit28?: string | number;
  edit29?: string | number;
  edit31?: string | number;
  edit34?: string | number;
  edit36?: string | number;
  edit37?: string | number;
  edit38?: string | number;
  edit39?: string | number;
  popupmenu3?: string | number;
  checkbox1?: boolean;
  checkbox2?: boolean;
  checkbox3?: boolean;
  checkbox4?: boolean;
}

export interface DriveInOutputsType {
  text2: string;
  text11: string;
  text12: string;
  text13: string;
  text14: string;
  text15: string;
  text16: string;
  text17: string;
  text25: string;
  text26: string;
  text27: string;
  text30: string;
  text31: string;
  text32: string;
  text33: string;
  text35: string;
  text36: string;
  text37: string;
  text39: string;
  text40: string;
  text42: string;
  text43: string;
  text44: string;
  text45: string;
  text46: string;
  text47: string;
  text48: string;
  text49: string;
  text50: string;
  text51: string;
  text59: string;
  text60: string;
  technical: Record<string, unknown> | null;
  warnings: string[];
}

export function calculateAll(inputs: DriveInInputsType = {}) {
  const warnings = [];
  const out: DriveInOutputsType = {
    text2: "",
    text30: "",
    text31: "",
    text32: "",
    text33: "",
    text35: "",
    text36: "",
    text37: "",
    text39: "",
    text40: "",
    text11: "",
    text46: "",
    text13: "",
    text42: "",
    text14: "",
    text50: "",
    text15: "",
    text51: "",
    text16: "",
    text47: "",
    text17: "",
    text45: "",
    text12: "",
    text43: "",
    text25: "",
    text49: "",
    text26: "",
    text48: "",
    text27: "",
    text44: "",
    text59: "",
    text60: "",
    technical: null,
    warnings: [],
  };

  const {
    edit1,
    edit2,
    edit3,
    edit4,
    edit5,
    edit6,
    edit7,
    edit9,
    edit27,
    edit28,
    edit29,
    edit31,
    edit34,
    edit36,
    edit37,
    edit38,
    edit39,
    popupmenu3,
    checkbox1,
    checkbox2,
    checkbox3,
    checkbox4,
  } = inputs;

  const NPal_in = parseMaybeNumber(edit1);
  const NPal = Number.isFinite(NPal_in.val) ? NPal_in.val + 1 : NaN;

  let PallH = parseMaybeNumber(edit2).val;
  if (Number.isFinite(PallH)) {
    PallH = 50 * Math.ceil(PallH / 50);
  }
  const Pallwt_kg = parseMaybeNumber(edit3).val;
  const Palld = parseMaybeNumber(edit4).val;
  const aisle_w = parseMaybeNumber(edit5).val;
  const PallW = parseMaybeNumber(edit6).val;
  const PAL_DEEP = parseMaybeNumber(edit7).val;

  const FRAMEwidth_input = parseMaybeNumber(edit9).val;
  let APR = checkbox1 ? 1 : 0;
  let BIP = checkbox2 ? 1 : 0;
  let W_reinf_flag = checkbox3 ? 1 : 0;
  let cantileveroffset = checkbox4 ? 1 : 0;

  const diffspacccc = parseMaybeNumber(edit28);
  let diffspac = 0;
  if (!diffspacccc.isNaN && (diffspacccc.val > 0 || diffspacccc.val < 0)) {
    diffspac = diffspacccc.val;
  }
  diffspac = Number.isFinite(diffspac) ? 50 * Math.ceil(diffspac / 50) : 0;

  const No_levels = Number.isFinite(NPal) ? NPal - 1 : NaN;

  const specifyheightframe = parseMaybeNumber(edit29).val;
  if (Number.isFinite(specifyheightframe) && specifyheightframe > 100) {
    PallH =
      50 *
      Math.ceil(
        ((specifyheightframe - 150 - diffspac) / (NPal || 1) - 200) / 50
      );
    out.text43 = fmtForUI(PallH);
    out.text25 = "Pallet Height";
    out.text2 = "NaN";
  }

  let HSTR = NaN;
  if (Number.isFinite(PallH) && Number.isFinite(NPal)) {
    HSTR = (PallH + 200) * NPal - 80 + diffspac;
  }
  const Hframe = Number.isFinite(HSTR) ? HSTR + 230 : NaN;
  if (Number.isFinite(specifyheightframe) && specifyheightframe > 100) {
    out.text43 = fmtForUI(Hframe);
  }

  let Sy = 355;

  const a = Number(popupmenu3 || 1);

  let A = 0,
    Agross = 0,
    Ixx = 0,
    Iyy = 0,
    X = 0,
    Y = 0;

  switch (a) {
    case 1:
      A = 0;
      Ixx = 0;
      Iyy = 0;
      X = 0;
      Y = 0;
      out.text31 = "Please Select the type uprights required";
      warnings.push(out.text31);
      break;
    case 2:
      A = parseMaybeNumber(edit34).val || 0;
      const ixx_custom_val = parseMaybeNumber(edit36).val || 0;
      Ixx = Math.pow(ixx_custom_val, 2) * (A || 1);
      const iyy_custom_val = parseMaybeNumber(edit37).val || 0;
      Iyy = Math.pow(iyy_custom_val, 2) * (A || 1);
      X = parseMaybeNumber(edit38).val || 0;
      Y = parseMaybeNumber(edit39).val || 0;
      break;
    case 3:
      A = 257.058;
      Agross = 389.532;
      Ixx = Math.pow(34.246, 2) * A;
      Iyy = Math.pow(17.958, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 4:
      A = 284.048;
      Agross = 431.265;
      Ixx = Math.pow(34.191, 2) * A;
      Iyy = Math.pow(17.93, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 5:
      A = 323.957;
      Agross = 493.297;
      Ixx = Math.pow(34.11, 2) * A;
      Iyy = Math.pow(17.889, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 6:
      A = 217.458;
      Agross = 389.532;
      Ixx = Math.pow(33.133, 2) * A;
      Iyy = Math.pow(19.001, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 7:
      A = 240.048;
      Agross = 431.265;
      Ixx = Math.pow(33.081, 2) * A;
      Iyy = Math.pow(18.968, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 8:
      A = 273.357;
      Agross = 493.297;
      Ixx = Math.pow(33.003, 2) * A;
      Iyy = Math.pow(18.919, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 9:
      A = 276.858;
      Agross = 389.532;
      Ixx = Math.pow(33.009, 2) * A;
      Iyy = Math.pow(17.973, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 10:
      A = 306.048;
      Agross = 431.265;
      Ixx = Math.pow(32.95, 2) * A;
      Iyy = Math.pow(17.944, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 11:
      A = 349.257;
      Agross = 493.297;
      Ixx = Math.pow(32.862, 2) * A;
      Iyy = Math.pow(17.903, 2) * A;
      X = 81.4;
      Y = 65;
      break;
    case 12:
      A = 418.155;
      Agross = 565.381;
      Ixx = Math.pow(37.426, 2) * A;
      Iyy = Math.pow(24.706, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 13:
      A = 514.95;
      Agross = 699.055;
      Ixx = Math.pow(37.288, 2) * A;
      Iyy = Math.pow(24.456, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 14:
      A = 566.437;
      Agross = 750.732;
      Ixx = Math.pow(44.614, 2) * A;
      Iyy = Math.pow(24.589, 2) * A;
      X = 120;
      Y = 77.4;
      break;
    case 15:
      A = 374.155;
      Agross = 565.381;
      Ixx = Math.pow(35.819, 2) * A;
      Iyy = Math.pow(25.383, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 16:
      A = 459.95;
      Agross = 699.055;
      Ixx = Math.pow(35.67, 2) * A;
      Iyy = Math.pow(25.129, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 17:
      A = 511.437;
      Agross = 750.732;
      Ixx = Math.pow(42.817, 2) * A;
      Iyy = Math.pow(25.359, 2) * A;
      X = 120;
      Y = 77.4;
      break;
    case 18:
      A = 440.155;
      Agross = 565.381;
      Ixx = Math.pow(36.486, 2) * A;
      Iyy = Math.pow(24.748, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 19:
      A = 542.45;
      Agross = 699.055;
      Ixx = Math.pow(36.337, 2) * A;
      Iyy = Math.pow(24.495, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 20:
      A = 593.937;
      Agross = 750.732;
      Ixx = Math.pow(43.575, 2) * A;
      Iyy = Math.pow(24.532, 2) * A;
      X = 120;
      Y = 77.4;
      break;
    case 21:
      A = 366.315;
      Agross = 487.712;
      Ixx = Math.pow(35.762, 2) * A;
      Iyy = Math.pow(19.236, 2) * A;
      X = 80;
      Y = 56;
      Sy = 275;
      break;
    case 22:
      A = 422.1;
      Agross = 0;
      Ixx = Math.pow(37.4, 2) * A;
      Iyy = Math.pow(25.2, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 23:
      A = 525.0;
      Agross = 0;
      Ixx = Math.pow(37.3, 2) * A;
      Iyy = Math.pow(25.4, 2) * A;
      X = 100;
      Y = 77;
      break;
    case 24:
      A = 448.9;
      Agross = 0;
      Ixx = Math.pow(44.7, 2) * A;
      Iyy = Math.pow(24.8, 2) * A;
      X = 120;
      Y = 77.4;
      break;
    case 25:
      A = 570.6;
      Agross = 0;
      Ixx = Math.pow(44.6, 2) * A;
      Iyy = Math.pow(25.3, 2) * A;
      X = 120;
      Y = 77.4;
      break;
    case 26:
      A = 617.4;
      Agross = 0;
      Ixx = Math.pow(51.8, 2) * A;
      Iyy = Math.pow(24.4, 2) * A;
      X = 140;
      Y = 77.4;
      break;
    case 27:
      A = 667;
      Agross = 0;
      Ixx = Math.pow(59, 2) * A;
      Iyy = Math.pow(24.2, 2) * A;
      X = 160;
      Y = 77.4;
      break;
    default:
      A = 0;
      Ixx = 0;
      Iyy = 0;
      X = 0;
      Y = 0;
      break;
  }

  if (
    !Number.isFinite(A) ||
    !Number.isFinite(Ixx) ||
    !Number.isFinite(Iyy) ||
    A === 0 ||
    Ixx === 0 ||
    Iyy === 0
  ) {
    out.text33 =
      "More Data is Required in order to complete Calculations or uprights invalid.";
    warnings.push(out.text33);
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy, X, Y };
    return out;
  }

  const E = 2.07e5;
  let L1 = Number.isFinite(PallH) ? 1.5 * PallH + 200 + diffspac : NaN;
  let L2 = Number.isFinite(PallH) ? PallH + 200 : NaN;

  let sigmaVal = 0;
  if (Number.isFinite(NPal) && Number.isFinite(L1) && Number.isFinite(L2)) {
    if (NPal === 2) {
      sigmaVal = L1;
    } else {
      const n = Math.max(0, No_levels - 1);
      let matSum = 0;
      for (let c = 1; c <= n; ++c) matSum += L1 + c * L2;
      sigmaVal = matSum + L1;
    }
  }
  const C_O_G =
    Number.isFinite(sigmaVal) && Number.isFinite(No_levels) && No_levels !== 0
      ? sigmaVal / No_levels
      : NaN;
  const ratio =
    Number.isFinite(C_O_G) && Number.isFinite(HSTR) ? C_O_G / HSTR : NaN;
  let kx = Number.isFinite(ratio) && ratio >= 2 / 3 ? 0.87 : 0.75;

  const rx = Math.sqrt(Ixx / A);
  const ry = Math.sqrt(Iyy / A);

  let SRx = (kx * HSTR) / (rx || 1e-12);
  let SRy = (0.85 * 1400) / (ry || 1e-12);
  SRx = Math.max(SRx, SRy);

  if (SRx > 200) {
    const msg =
      "THIS SLENDERNESS RATIO EXCEEDS THE MAXIMUM VALUE OF 200 AS ALLOWABLE UNDER SEMA GUIDELINES";
    warnings.push(msg);
    out.text31 = msg;
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy, rx, ry, SRx, SRy };
    return out;
  } else if (SRx < 60) {
    const msg = "SLENDERNESS RATIOS LESS THAN 60 ARE NOT PERMISSIBLE";
    warnings.push(msg);
    out.text31 = msg;
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy, rx, ry, SRx, SRy };
    return out;
  }

  const Pcr = (Math.PI ** 2 * E * A) / SRx ** 2;
  const Perry = SRx <= 20 ? 0.0 : 0.002 * (SRx - 20);
  const acoef = A * Sy + (1 + Perry) * Pcr;
  const bcoef = 4 * (A * Sy) * Pcr;
  const disc = Math.max(0, acoef * acoef - bcoef);
  const Pc5950 = 0.5 * (acoef - Math.sqrt(disc));
  const Pc_final = Math.min(Pcr, Pc5950);
  const Pc_KN = Pc_final / 1000;

  const sideloaddddd = parseMaybeNumber(edit31).val;
  const sideload = Number.isFinite(sideloaddddd) ? sideloaddddd / 100 : 0;

  const L_cant =
    Number.isFinite(aisle_w) && Number.isFinite(PallW)
      ? aisle_w - PallW + 20
      : NaN;

  const offset = cantileveroffset == 1 ? Y / 2 + 30 : 0;

  const Mmax = (Sy * Ixx) / (X / 2) / 1000;
  const Mymax = (Sy * Iyy) / (Y / 2) / 1000;

  const Level1 = Number.isFinite(PallH) ? PallH + 200 + diffspac : NaN;

  const cVal = (2 * No_levels) / (Pc_KN || 1e-12);
  const dVal = 0.5 * ((2 * sideload * Level1 * No_levels) / (Mmax || 1e-12));
  const d1Val = 0.5 * ((2 * offset) / (Mymax || 1e-12));
  let wc = 1 / (cVal + dVal + d1Val);

  let wc_patt2 = Infinity;
  if (NPal > 2) {
    const e = (2 * No_levels - 3) / (Pc_KN || 1e-12);
    const f = (L_cant + X / 2) / (Mmax || 1e-12);
    const f2 = (0.5 * offset) / (Mymax || 1e-12);
    wc_patt2 = 1 / (e + f + f2);
    wc = Math.min(wc, wc_patt2);
  }

  const kVal = (2 * No_levels - 1) / (Pc_KN || 1e-12);
  const lVal = ((L_cant + X / 2) * Level1) / ((HSTR || 1e-12) * Mmax);
  const l2Val = (0.5 * offset) / (Mymax || 1e-12);
  const wc_patt1 = 1 / (kVal + lVal + l2Val);

  wc = Math.min(wc_patt1, wc);

  let n = No_levels;
  let FACTN = 0;
  while (n > 0) {
    FACTN = FACTN + n;
    n = n - 1;
  }
  const hVal = 2 / (Pc_KN || 1e-12);
  const jVal =
    (2 * (FACTN * (PallH + 200) + diffspac * No_levels) * sideload) /
    (Mmax || 1e-12);
  const j2Val = (0.5 * offset) / (Mymax || 1e-12);
  const wc_oastab = 1 / (hVal + jVal + j2Val);

  wc = Math.min(wc, wc_oastab);

  let pattTxt =
    "Maximum cantilever load has not been affected by pattern load considerations";
  if (NPal > 2 && Number.isFinite(wc_patt2) && wc_patt2 - wc < 0.1) {
    pattTxt =
      "Maximum cantilever load is determined by (Type 2) alternate pallets missing at levels 1 and 2";
  } else if (Math.abs(wc_patt1 - wc) < 0.1) {
    pattTxt =
      "Maximum cantilever load is determined by (Type 1) one pallet missing on the bottom cantilever level";
  } else if (Math.abs(wc_oastab - wc) < 0.1) {
    pattTxt =
      "Maximum cantilever load is determined by Overall Stability top-tie resistance to nominal side-loads";
  }

  out.text32 = pattTxt;

  const FOS = 1.5;
  const wa = wc / FOS;
  const wa_kg = (wa * 1000) / 9.81;
  const pa_frame = 2 * (2 * wa * No_levels);
  const Pa_kg = (pa_frame * 1000) / 9.81;

  const Pallwt_kn = (Pallwt_kg * 9.81) / 1000;
  const DIR_load = (Pallwt_kn * 1000) / (2 * Palld);
  let DMax = 2 * ((1000 * wa) / (DIR_load || 1e-12));

  const Ixx80 = 48.25 * Math.pow(10, 4);
  const Lmax1 = Math.sqrt((8 * Sy * Ixx80) / (FOS * 40 * (DIR_load || 1e-12)));
  const Lmax2 = Math.pow((0.384 * E * Ixx80) / (DIR_load || 1e-12), 1 / 3);
  const Lmax_rail = Math.min(Lmax1, Lmax2);

  if (DMax < 450) {
    out.text33 =
      "Section chosen will not be suitable as DMax<450, consider beginning again with a heavier uprights";
    warnings.push(out.text33);
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy, Pc_KN };
    return out;
  }

  let WFRAME;
  if (DMax < 1200) WFRAME = 600;
  else if (DMax <= 1500) WFRAME = 750;
  else if (DMax <= 2100) WFRAME = 900;
  else WFRAME = 1200;

  let DSTR = Palld * PAL_DEEP + (PAL_DEEP - 1) * 50 - 100;

  let APRd = 0;
  if (APR > 0.1) {
    APRd = Palld - 100.0;
    const APRdepthhh = parseMaybeNumber(edit27).val;
    if (Number.isFinite(APRdepthhh) && APRdepthhh > 100) APRd = APRdepthhh;
  }

  if (W_reinf_flag < 0.1) {
    if (Number.isFinite(FRAMEwidth_input) && FRAMEwidth_input >= DMax) {
      const msg = "WARNING : Endframe width must be less than than Dmax";
      warnings.push(msg);
      out.text35 = msg;
    }
    if (
      Number.isFinite(FRAMEwidth_input) &&
      FRAMEwidth_input > 100 &&
      FRAMEwidth_input < DMax
    ) {
      WFRAME = FRAMEwidth_input;
    }
  }

  DMax = Math.min(DMax, WFRAME + Lmax_rail);

  let BIPd = 0;
  if (BIP > 0.1) BIPd = Y * 2;

  const Max_GAP = DMax - WFRAME;
  let No_FRAMES = 1 - APR;
  let GAP =
    (DSTR - APRd - BIPd - WFRAME * No_FRAMES) / (No_FRAMES - 1 + APR + BIP);

  while (GAP > Max_GAP) {
    No_FRAMES = No_FRAMES + 1;
    GAP =
      (DSTR - APRd - BIPd - WFRAME * No_FRAMES) / (No_FRAMES - 1 + APR + BIP);
    if (No_FRAMES > 1000) break;
  }

  let LOAD_USE = 100.0 * ((WFRAME + GAP) / DMax);
  let LOAD_USE1 = 0;
  let Level = 0;

  let sethandleszero = 0;
  if (W_reinf_flag < 0.1) {
    if (Math.abs(WFRAME - GAP) > 151) {
      const msg =
        "WARNING: PLEASE CHECK THE GAP BETWEEN FRAMES VERSUS THE WIDTH OF FRAMES IS SUITABLE MATCHED";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }
    if (GAP < 299) {
      const msg =
        "THE GAP BETWEEN FRAMES IS LESS THAN 300MM, CONSIDER RENIFORCING THE FRAMES OR CHANGING WIDTH OF FRAMES";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }
    if (GAP > 1651) {
      const msg =
        "THE GAP BETWEEN FRAMES IS GREATER THAN 1650MM, CONSIDER CHANGING THE WIDTH OF FRAMES OR INSERT A BIP";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }
  }

  if (W_reinf_flag < 0.1) {
    out.text44 = Number.isFinite(sideload) ? fmtForUI(sideload * 100.0) : "";
    out.text39 = "% Side Load";
    out.text40 = Number.isFinite(DSTR + 100.0) ? fmtForUI(DSTR + 100.0) : "";
    out.text11 = "Depth Structure";
    out.text46 = Number.isFinite(No_FRAMES)
      ? String(Math.round(No_FRAMES))
      : "";
    out.text13 = "Number Frames";
    out.text42 = Number.isFinite(WFRAME) ? fmtForUI(WFRAME) : "";
    out.text14 = "Width Frames";
    out.text50 = String(Math.round(APR));
    out.text15 = "Number APR";
    if (Math.abs(APR) > 0.1) {
      out.text51 = fmtForUI(APRd);
      out.text16 = "Width APR";
    }
    out.text47 = String(Math.round(BIP));
    out.text17 = "Number BIP";
    out.text45 = Number.isFinite(GAP) ? fmtForUI(GAP) : "";
    out.text12 = "Gap Between Frames";
    if (Number.isFinite(specifyheightframe) && specifyheightframe < 100) {
      out.text43 = fmtForUI(HSTR + 230);
      out.text25 = "Height Frames";
    }
    out.text49 = Number.isFinite(LOAD_USE) ? fmtForUI(LOAD_USE) : "";
    out.text26 = "% Load Used At Base";
    out.text60 = String(FOS);
    out.text59 = "FOS";
  }

  if (W_reinf_flag > 0.1 && WFRAME + GAP > 2800) {
    out.text37 = "DIR endframes will not require reinforcement";
  }

  if (W_reinf_flag > 0.1 && WFRAME + GAP < 2800) {
    const Dmax_reinf = DMax * 2;
    let W_reinf_val = 0;
    if (WFRAME + GAP < 900) W_reinf_val = 750;
    else if (WFRAME + GAP < 1200) W_reinf_val = 900;
    else W_reinf_val = 1200;

    const FRAMEwidthhh = parseMaybeNumber(edit9).val;
    if (FRAMEwidthhh >= Dmax_reinf) {
      const msg = "WARNING : Endframe width must be less than than Dmax_reinf";
      warnings.push(msg);
      out.text35 = msg;
    }
    if (FRAMEwidthhh > 100 && FRAMEwidthhh < Dmax_reinf) {
      W_reinf_val = FRAMEwidthhh;
    }

    let Max_GAP_reinf = Dmax_reinf - W_reinf_val;
    if (Max_GAP_reinf > Lmax_rail) {
      Max_GAP_reinf = Lmax_rail;
    }

    let No_reinf = 2 - APR;
    let GAP_reinf =
      (DSTR - APRd - BIPd - No_reinf * W_reinf_val) /
      (No_reinf - 1 + APR + BIP);
    while (GAP_reinf > Max_GAP_reinf) {
      No_reinf = No_reinf + 1;
      GAP_reinf =
        (DSTR - APRd - BIPd - No_reinf * W_reinf_val) /
        (No_reinf - 1 + APR + BIP);
      if (No_reinf > 1000) break;
    }

    if (BIP > 0.1 && BIPd + GAP_reinf > Dmax_reinf / 2.0) {
      const msg =
        "WARNING - THE BIPOLE HAS BEEN OVERLOADED - Please try increasing the frame width, or else remove the bipole";
      warnings.push(msg);
      out.text35 = msg;
    }

    const d_leg = (W_reinf_val + GAP_reinf) / 2.0;
    const P_cant = (d_leg * DIR_load) / 1000;
    const Pa_reinf = (Pc_KN * 2.0) / FOS;
    const Ma_reinf = (Mmax * 2.0) / FOS;
    const Mya_reinf = (4.0 * Mymax) / FOS;

    Level = 0;
    let SF = 0;
    let toptie = 0;
    let FACTN2 = 0;
    const H = 2.0 * P_cant * sideload;
    const Fval = H * No_levels;
    const leveldiff = PallH + 200;
    const M_base = (Fval * Level1) / 2.0;
    let My_local = 0.5 * (2.0 * P_cant * (offset + Y / 2.0));
    while (SF < 1.5 && Level <= No_levels) {
      FACTN2 = FACTN2 + Level;
      Level = Level + 1;
      const P = P_cant * 2.0 * (No_levels - Level + 1);
      const M =
        Fval * (Level1 + (Level - 1) * leveldiff) -
        FACTN2 * H * leveldiff -
        M_base;
      SF = 1.0 / (P / Pa_reinf + M / Ma_reinf + My_local / Mya_reinf);
      if (Math.abs(Level - 1) < 0.1) {
        LOAD_USE = 100.0 / SF;
      }
      if (Level > 1000) break;
    }

    if (No_levels + 1 - Level < 0.1 && SF < 2.0) {
      toptie = 1;
    }

    SF = 0;
    let patt1_lev = 0;
    let P = 0,
      M = 0;
    My_local = My_local / 2.0;

    while (SF < 1.5 && patt1_lev < No_levels) {
      patt1_lev = patt1_lev + 1;
      const leverage = (Level1 + (patt1_lev - 1) * leveldiff) / HSTR;
      P = P_cant * (2.0 * (No_levels - patt1_lev) + 1);
      M = P_cant * (L_cant + X / 2) * leverage;
      SF = 1.0 / (P / Pa_reinf + M / Ma_reinf + My_local / Mya_reinf);

      if (Math.abs(patt1_lev - 1) < 0.1) {
        LOAD_USE1 = 100.0 / SF;
      }
      if (patt1_lev > 1000) break;
    }

    let patt2_lev = 1;
    SF = 0;
    while (SF < 1.5 && patt2_lev < No_levels) {
      patt2_lev = patt2_lev + 1;
      P = P_cant * (2.0 * (No_levels - patt2_lev) + 1);
      M = P_cant * (L_cant + X / 2);
      SF = 1.0 / (P / Pa_reinf + M / Ma_reinf + My_local / Mya_reinf);
      if (patt2_lev > 1000) break;
    }

    const mylevelll = Math.max(patt2_lev, patt1_lev);
    const Level_Of_Reinforcement = Math.max(mylevelll, Level) - 1;
    let load_used_at_base_ = Math.max(LOAD_USE, LOAD_USE1);

    if (patt1_lev - Level > 0.1) {
      if (patt1_lev - patt2_lev > 0.1) {
        out.text36 =
          "Reinforcement requirements have been determined by type 1 Pattern Loading";
      } else {
        out.text36 =
          "Reinforcement requirements have been affected by both type 1 and type 2 pattern loading";
      }
      Level = patt1_lev;
    } else if (patt2_lev - Level > 0.1) {
      out.text36 =
        "Reinforcement requirements have been determined by Type 2 pattern Loading";
      Level = patt2_lev;
    } else {
      out.text36 =
        "Reinforcement requirements have NOT been affected by pattern Loadings";
    }

    if (patt1_lev - 1 < 0.1 && LOAD_USE1 > LOAD_USE) {
      out.text30 =
        "Base zone LOAD USE percentage has been determined by type 1 pattern loading ";
      LOAD_USE = LOAD_USE1;
    } else {
      out.text30 =
        "Base zone LOAD USE percentage has NOT been determined by pattern loading";
    }

    out.text44 = Number.isFinite(sideload) ? fmtForUI(sideload * 100.0) : "";
    out.text39 = "% Side Load";
    out.text40 = Number.isFinite(DSTR + 100.0) ? fmtForUI(DSTR + 100.0) : "";
    out.text11 = "Depth Structure";
    out.text46 = Number.isFinite(No_reinf) ? String(Math.round(No_reinf)) : "";
    out.text13 = "Number Frames";
    out.text42 = Number.isFinite(W_reinf_val) ? fmtForUI(W_reinf_val) : "";
    out.text14 = "Width Frames";
    out.text50 = String(Math.round(APR));
    out.text15 = "Number APR";
    if (Math.abs(APR) > 0.1) {
      out.text51 = fmtForUI(APRd);
      out.text16 = "Width APR";
    }
    out.text47 = String(Math.round(BIP));
    out.text17 = "Number BIP";

    if (Math.abs(W_reinf_val - GAP_reinf) > 151) {
      const msg =
        "WARNING: PLEASE CHECK THE GAP BETWEEN FRAMES VERSUS THE WIDTH OF FRAMES IS SUITABLE MATCHED";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }
    if (GAP_reinf < 299) {
      const msg =
        "THE GAP BETWEEN FRAMES IS LESS THAN 300MM, CONSIDER USING A HEAVIER UPRIGHTS OR CHANGING WIDTH OF FRAMES";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }
    if (GAP_reinf > 1651) {
      const msg =
        "THE GAP BETWEEN FRAMES IS GREATER THAN 1650MM, CONSIDER CHANGING THE WIDTH OF FRAMES OR INSERT A BIP";
      warnings.push(msg);
      out.text31 = msg;
      sethandleszero = 1;
    }

    out.text45 = Number.isFinite(GAP_reinf) ? fmtForUI(GAP_reinf) : "";
    out.text12 = "Gap Between Frames";
    if (Number.isFinite(specifyheightframe) && specifyheightframe < 100) {
      out.text43 = fmtForUI(Hframe);
      out.text25 = "Height Frames";
    }
    out.text60 = String(FOS);
    out.text59 = "FOS";
    out.text49 = Number.isFinite(LOAD_USE) ? fmtForUI(LOAD_USE) : "";
    out.text26 = "% Load Used At Base";

    if (toptie > 0.1) {
      out.text37 =
        "All DIR endframes will require reinforcement to above top-tie level";
    } else if (Math.abs(Level - 1) < 0.1) {
      out.text37 = "DIR endframes will not in fact require reinforcement";
    } else {
      out.text37 = "All DIR endframes will require reinforcement";
      out.text48 = String(Math.max(0, Level - 1));
      out.text27 = "Reinforcement Level";
    }
  }

  if (PallW > aisle_w) {
    out.text33 = "PALLET WIDTH CANNOT BE GREATER THAN THE AISLE WIDTH";
    warnings.push(out.text33);
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy };
    return out;
  }

  if (
    !Number.isFinite(A) ||
    !Number.isFinite(Sy) ||
    !Number.isFinite(Ixx) ||
    !Number.isFinite(Iyy) ||
    !Number.isFinite(X) ||
    !Number.isFinite(Y) ||
    !Number.isFinite(NPal) ||
    !Number.isFinite(Pallwt_kg) ||
    !Number.isFinite(Palld) ||
    !Number.isFinite(aisle_w) ||
    !Number.isFinite(PallW) ||
    !Number.isFinite(PAL_DEEP)
  ) {
    out.text33 = "More Data is Required in order to complete Calculations";
    warnings.push(out.text33);
    out.warnings = warnings;
    out.technical = { A, Ixx, Iyy };
    return out;
  }

  out.technical = {
    A,
    Agross,
    Ixx,
    Iyy,
    X,
    Y,
    rx,
    ry,
    SRx,
    SRy,
    Pcr,
    Perry,
    Pc_final,
    Pc_KN,
    wa_kg,
    DMax,
    Lmax_rail,
  };

  out.warnings = warnings;
  return out;
}
